export const airports = [{
    title: 	"Paris Charles de Gaulle (CDG)",
    value: "CDG-sky"
  },{
    title: 	"Paris Orly (ORY)",
    value: "ORY-sky"
  },{
    title: 	"Nice-Côte d'Azur (NCE)",
    value: "NCE-sky"
  },{
    title: 	"Lyon-Saint-Exupéry (LYS)",
    value: "LYS-sky"
  },{
    title: 	"Marseille-Provence (MRS)",
    value: "MRS-sky"
  },{
    title: 	"Toulouse-Blagnac (TLS)",
    value: "TLS-sky"
  },{
    title: 	"Bâle-Mulhouse-Fribourg (MLH)",
    value: "MLH-sky"
  },{
    title: 	"Bordeaux-Mérignac (BOD)",
    value: "BOD-sky"
  },{
    title: 	"Nantes-Atlantique (NTE)",
    value: "NTE-sky"
  },{
    title: "Genève Cointrin (GVA)",
    value: "GVA-sky"
},{
    title: "Hambourg (HAM)",
    value: "HAM-sky"
}]

export const countries = [{
      title: 'Afrique du Sud',
      value: 'za'
  },{
      title: 'Algérie',
      value: 'dz'
  },{
      title: 'Allemagne',
      value: 'de'
  },{
      title: 'Angleterre',
      value: 'uk'
  },{
      title: 'Arabie Saoudite',
      value: 'sa'
  },{
      title: 'Argentine',
      value: 'ar'
  },{
      title: 'Australie',
      value: 'au'
  },{
      title: 'Autriche',
      value: 'at'
  },{
      title: 'Belgique',
      value: 'be'
  },{
      title: 'Bahamas',
      value: 'bs'
  },{
      title: 'Belize',
      value: 'bz'
  },{
      title: 'Bhoutan',
      value: 'bt'
  },{
      title: 'Bolivie',
      value: 'bo'
  },{
      title: 'Bulgarie',
      value: 'bg'
  },{
      title: 'Birmanie',
      value: 'mm'
  },{
      title: 'Cambodge',
      value: 'kh'
  },{
      title: 'Cameroun',
      value: 'cm'
  },{
      title: 'Canada',
      value: 'ca'
  },{
      title: 'Cap Vert',
      value: 'cv'
  },{
      title: 'Chili',
      value: 'cl'
  },{
      title: 'Chine',
      value: 'cn'
  },{
      title: 'Corée du Sud',
      value: 'kr'
  },{
      title: 'Colombie',
      value: 'co'
  },{
      title: 'Costa Rica',
      value: 'cr'
  },{
      title: "Côte d'Ivoire",
      value: 'ci'
  },{
      title: 'Croatie',
      value: 'hr'
  },{
      title: 'Cuba',
      value: 'cu'
  },{
      title: 'Chypre',
      value: 'cy'
  },{
      title: 'Danemark',
      value: 'dk'
  },{
      title: 'République Dominicaine',
      value: 'do'
  },{
      title: 'Emirats Arabes Unis',
      value: 'ae'
  },{
      title: 'Equateur',
      value: 'ec'
  },{
      title: 'Egypte',
      value: 'eg'
  },{
      title: 'Espagne',
      value: 'es'
  },{
      title: 'Estonie',
      value: 'ee'
  },{
      title: 'Etats-Unis',
      value: 'us'
  },{
      title: 'Ethiopie',
      value: 'et'
  },{
      title: 'Iles Féroé',
      value: 'fo'
  },{
      title: 'Fidji',
      value: 'fj'
  },{
      title: 'Finlande',
      value: 'fi'
  },{
      title: 'France',
      value: 'fr'
  },{
      title: 'Guyane Française',
      value: 'gf'
  },{
      title: 'Gabon',
      value: 'ga'
  },{
      title: 'Géorgie',
      value: 'ge'
  },{
      title: 'Grèce',
      value: 'gr'
  },{
      title: 'Guadeloupe',
      value: 'gp'
  },{
      title: 'Guatemala',
      value: 'gt'
  },{
      title: 'Hong Kong',
      value: 'hk'
  },{
      title: 'Hongrie',
      value: 'hu'
  },{
      title: 'Islande',
      value: 'is'
  },{
      title: 'Inde',
      value: 'in'
  },{
      title: 'Indonésie',
      value: 'id'
  },{
      title: 'Iran',
      value: 'ir'
  },{
      title: 'Irlande',
      value: 'ie'
  },{
      title: 'Israël',
      value: 'il'
  },{
      title: 'Italie',
      value: 'it'
  },{
      title: 'Jamaïque',
      value: 'jm'
  },{
      title: 'Japon',
      value: 'jp'
  },{
      title: 'Jordanie',
      value: 'jo'
  },{
      title: 'Kenya',
      value: 'ke'
  },{
      title: 'Laos',
      value: 'la'
  },{
      title: 'Lettonie',
      value: 'lv'
  },{
      title: 'Liban',
      value: 'lb'
  },{
      title: 'Lituanie',
      value: 'lt'
  },{
      title: 'Luxembourg',
      value: 'lu'
  },{
      title: 'Macédoine du Nord',
      value: 'mk'
  },{
      title: 'Madagascar',
      value: 'mg'
  },{
      title: 'Malaisie',
      value: 'my'
  },{
      title: 'Maldives',
      value: 'mv'
  },{
      title: 'Malte',
      value: 'mt'
  },{
      title: 'Martinique',
      value: 'mq'
  },{
      title: 'Ile Maurice',
      value: 'mu'
  },{
      title: 'Mayotte',
      value: 'yt'
  },{
      title: 'Mexique',
      value: 'mx'
  },{
      title: 'Moldavie',
      value: 'md'
  },{
      title: 'Mongolie',
      value: 'mn'
  },{
      title: 'Maroc',
      value: 'ma'
  },{
      title: 'Namibie',
      value: 'na'
  },{
      title: 'Népal',
      value: 'np'
  },{
      title: 'Nouvelle-Zélande',
      value: 'nz'
  },{
      title: 'Nicaragua',
      value: 'ng'
  },{
      title: 'Norvège',
      value: 'no'
  },{
      title: 'Oman',
      value: 'om'
  },{
      title: 'Panama',
      value: 'pa'
  },{
      title: 'Paraguay',
      value: 'py'
  },{
      title: 'Pays-Bas',
      value: 'nl'
  },{
      title: 'Pérou',
      value: 'pe'
  },{
      title: 'Philippines',
      value: 'ph'
  },{
      title: 'Pologne',
      value: 'pl'
  },{
      title: 'Portugal',
      value: 'pt'
  },{
      title: 'Porto Rico',
      value: 'pr'
  },{
      title: 'La Réunion',
      value: 're'
  },{
      title: 'Roumanie',
      value: 'ro'
  },{
      title: 'Russie',
      value: 'ru'
  },{
      title: 'Sénégal',
      value: 'sn'
  },{
      title: 'Serbie',
      value: 'yu'
  },{
      title: 'Seychelles',
      value: 'sc'
  },{
      title: 'Singapour',
      value: 'sg'
  },{
      title: 'Slovaqie',
      value: 'sk'
  },{
      title: 'Slovénie',
      value: 'si'
  },{
      title: 'Sri Lanka',
      value: 'lk'
  },{
      title: 'Suède',
      value: 'se'
  },{
      title: 'Suisse',
      value: 'su'
  },{
      title: 'Taïwan',
      value: 'tw'
  },{
      title: 'Tanzanie',
      value: 'tz'
  },{
      title: 'Tchéquie',
      value: 'cz'
  },{
      title: 'Thaïlande',
      value: 'th'
  },{
      title: 'Tunisie',
      value: 'tn'
  },{
      title: 'Turquie',
      value: 'tr'
  },{
      title: 'Ukraine',
      value: 'ua'
  },{
      title: 'Uruguay',
      value: 'uy'
  },{
      title: 'Venezuela',
      value: 've'
  },{
      title: 'Vietnam',
      value: 'vn'
  },{
      title: 'Sans préférence',
      value: 'anywhere'
}]

export const ranges = [
    {
        title: "N'importe",
        value: [0]
    },{
        title: '1 week-end',
        value: [2]
    },{
        title: '3 jours',
        value: [3]
    },{
        title: '4 jours',
        value: [4]
    },{
        title: '5 jours',
        value: [5]
    },{
        title: '1 semaine',
        value: [6,7,8]
    },{
        title: '10 jours',
        value: [9,10,11]
    },{
        title: '2 semaines',
        value: [12,13,14,15,16]
    },{
        title: '3 semaines',
        value: [19,20,21,22,23]
    },{
        title: '1 mois',
        value: [27,28,29,30,31,32,33,34]
    }
]

export const peopleNumber = [{
      title: "0",
      value: "0"
  },{
      title: "1",
      value: "1"
  },{
      title: "2",
      value: "2"
  },{
      title: "3",
      value: "3"
  },{
      title: "4",
      value: "4"
  },{
      title: "5",
      value: "5"
  },{
      title: "6",
      value: "6"
  },{
      title: "7",
      value: "7"
}]

export const seasons = [{
      title: "N'importe",
      value: "anytime"
  },{
      title: "Janvier",
      value: "2022-01"
  },{
      title: "Février",
      value: "2022-02"
  },{
      title: "Mars",
      value: "2022-03"
  },{
      title: "Avril",
      value: "2022-04"
  },{
      title: "Mai",
      value: "2022-05"
  },{
      title: "Juin",
      value: "2022-06"
  },{
      title: "Juillet",
      value: "2022-07"
  },{
      title: "Août",
      value: "2022-08"
  },{
      title: "Septembre",
      value: "2022-09"
  },{
      title: "Octobre",
      value: "2022-10"
  },{
      title: "Novembre",
      value: "2021-11"
  },{
      title: "Décembre",
      value: "2020-12"
}]